import { render, staticRenderFns } from "./ProductEditSEO.vue?vue&type=template&id=0f9b7060&"
import script from "./ProductEditSEO.vue?vue&type=script&lang=js&"
export * from "./ProductEditSEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports